import React from "react";
import "./PiPopupWindowPreview.css";
import classNames from "classnames";

interface PiPopupWindowPreviewProps {
  title?: React.ReactNode;
  body: React.ReactNode;
  footer?: React.ReactNode;
  size?: "large" | "medium" | "compact" | "small" | "full";
  hideBottom?: Boolean;
}

export default function PiPopupWindowPreview(props: PiPopupWindowPreviewProps) {
  const { title, body, footer, size, hideBottom } = { ...props };

  //const sizeClasses = size ? "pipopupwindowpreview-size-" + size : "pipopupwindowpreview-size-large";

  const sizeClasses = classNames({
    "pipopupwindowpreview-size-large": size === undefined || size === "large",
    "pipopupwindowpreview-size-compact": size === "compact",
    "pipopupwindowpreview-size-small": size === "small",
    "w-[90%] h-[55%]": size === "medium",
    "w-full h-full rounded-none p-0": size === "full",
    "px-[16px] py-[32px] rounded-[5px]": size !== "full",
  });

  return (
    <>
      <div
        className={
          (hideBottom
            ? "pipopupwindowpreview-root-no-bottom "
            : "pipopupwindowpreview-root ") + sizeClasses
        }
      >
        {size !== "full" && (
          <div
            aria-label="pipopupwindowpreview-title"
            className="pipopupwindowpreview-title"
          >
            {title}
          </div>
        )}
        <div
          aria-label="pipopupwindowpreview-body"
          className={classNames({
            "pipopupwindowpreview-body-normal": footer,
            "pipopupwindowpreview-body-extended": !footer && size !== "full",
            "h-full w-full m-0": size === "full",
          })}
        >
          {body}
        </div>
        {footer && (
          <div
            aria-label="pipopupwindowpreview-footer"
            className="pipopupwindowpreview-footer"
          >
            {footer}
          </div>
        )}
      </div>
    </>
  );
}
